export default __webpack_public_path__ + "static/media/swager.3f17ed3d.png";